import { compose } from '@reduxjs/toolkit';

import NavBar from './Navbar.layout';


const decorate = compose();
export default decorate(NavBar);
